module.exports = "<div> <group title=Default></group> <switch :value.sync=switcher.checked></switch> <group title=Disalbed></group> <switch :value.sync=switcher.checked :disabled=true></switch> <group title=GroupItem> <switch :value.sync=switcher2.checked :is-group-item=switcher2.isGroupItem :title=switcher2.title></switch> </group> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demos/Switch.vue
 ** module id = 200
 ** module chunks = 0
 **/